var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_192",
    "data-name": "Group 192",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.289,
    height: 105.985,
    viewBox: "0 0 94.289 105.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M46.076,58.331a5.823,5.823,0,1,0-5.823,5.822,5.822,5.822,0,0,0,5.823-5.822",
    transform: "translate(-3.015 -4.599)",
    fill: "#e6f1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M61.859,52.509a5.823,5.823,0,1,0,5.822,5.822,5.822,5.822,0,0,0-5.822-5.822",
    transform: "translate(-4.908 -4.599)",
    fill: "#e6f1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M89.777,23.084,51.657,1.075a10.011,10.011,0,0,0-9.024,0L4.512,23.084A10.018,10.018,0,0,0,0,30.9L0,74.947A10.049,10.049,0,0,0,4.532,82.8L42.826,104.9a10.052,10.052,0,0,0,9.065,0L71.037,93.851l-.158-.133,18.877-10.9a10.063,10.063,0,0,0,4.533-7.853V30.9a10.011,10.011,0,0,0-4.512-7.814M75.972,64.393a10.06,10.06,0,0,1-4.533,7.851l-4.223,2.437L70.53,93.425l-14.418-12.1-4.221,2.435a10.046,10.046,0,0,1-9.065,0L22.847,72.224a10.062,10.062,0,0,1-4.529-7.85V41.414a9.988,9.988,0,0,1,4.5-7.793l19.831-11.45a10,10,0,0,1,9,0L71.473,33.623a9.977,9.977,0,0,1,4.5,7.79Z",
    transform: "translate(0 0)",
    fill: "#e6f1f3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.c3def121e0bc451fc7d01042c8abb866.svg";
export { ForwardRef as ReactComponent };